<div class="w-screen max-w-sm">
  <div class="grid">
    <div class="flex flex-col justify-between overflow-hidden">
      @if (errorMessage()) {
        <div class="my-4 rounded-md bg-aux-error p-5 font-medium text-white">
          {{ errorMessage() }}
        </div>
      }

      <div>
        <div
          class="aux-link mb-4 flex cursor-pointer justify-center"
          (click)="downloadVendorEstimateTemplate()"
        >
          @if (templateLoading$ | async) {
            <span class="spinner mr-3 h-6 w-6"></span>
          }
          @if ((templateLoading$ | async) === false) {
            <span>
              <aux-icon name="Download" />
            </span>
          }
          Download Vendor Estimate Template
        </div>
        <div class="mb-4">
          <div class="mb-2 text-xs">Month</div>
          <ng-container *ngVar="currentMonth$ | async as currentMonth">
            <ng-select
              placeholder="Select"
              id="months"
              class="month-select"
              [formControl]="selectedMonth"
              [appendTo]="'body'"
              [searchable]="true"
              [clearable]="false"
              [items]="availableMonths"
              bindLabel="name"
              bindValue="date"
            >
              <ng-template let-item="item" ng-option-tmp>
                <ng-container *ngVar="currentMonth === item?.date && workflowLocked as isDisabled">
                  @if (isDisabled) {
                    <div
                      class="l-0 t-0 disabled-option absolute -ml-3 -mt-2 h-full w-full cursor-not-allowed"
                      (click)="onDisabledOptionClick($event)"
                      [auxTooltip]="MessagesConstants.VENDOR_ESTIMATES_LOCKED"
                    ></div>
                  }
                  <span
                    class="ng-option-label"
                    [class.disabled-option-label]="isDisabled"
                    [title]="item?.date"
                  >
                    {{ item?.name }}
                  </span>
                </ng-container>
              </ng-template>
            </ng-select>
          </ng-container>
        </div>
        <div class="mb-4">
          <div class="mb-2 text-xs">Vendor Contract</div>
          <ng-select
            placeholder="Select"
            id="vendors"
            [formControl]="selectedVendor"
            [appendTo]="'body'"
            [searchable]="true"
            [clearable]="false"
          >
            @for (vendor of vendorsQuery.allReceivesEstimateVendors$ | async; track vendor) {
              <ng-option [value]="vendor.id">
                <span [title]="vendor.name">{{ vendor.name }}</span>
              </ng-option>
            }
          </ng-select>
        </div>
        <aux-file-manager
          #manager
          class="h-48"
          [fetchFilesOnInit]="false"
          [pathFn]="pathFn"
          [eager]="false"
          [metadata]="metadata"
          [accept]="'.csv'"
          [showSuccessOnUpload]="true"
        />
      </div>
      <div class="mt-4 max-h-60 max-w-sm overflow-auto">
        <aux-file-viewer
          [fileManager]="manager"
          [disableFirstFileMargin]="true"
          [onlyShowUploaded]="false"
        />
      </div>
    </div>
  </div>
</div>
